<template lang="pug">
    v-list-tile(style="overflow: hidden;" @click="$emit('click')")
        v-layout.main-tile(row)
            v-flex.pr-2.xs2.text-sm-center.d-flex.align-center
                CounterControl.mr-3(
                    v-if="value.stock >= 1 || activeTransaction.id === 3"
                    :value="value.quantity"
                    @input="handleCounter($event)"
                    infoLabel="Stock: "
                    :infoValue="value.stock >= value.quantity ? value.stock - value.quantity : 0"
                    :sideControls="false"
                    :minValue="0"
                    :maxValue="activeTransaction.id === 3 ? false : value.stock"
                    @blur="$emit('blur')"
                    ref="counter"
                    )
                span.font-weight-bold.title.red--text.text-sm-center(v-else style="top: 5px;") sin stock
            v-divider(vertical)
            v-flex(:class="stripLayout.detailsTile")
                slot(v-if="enableDescriptionSlot" name="description")
                SalesCartItemDetails(v-else
                    :item="item"
                    ref="details"
                    @price:replace="handlePriceReplace($event)"
                    )
                v-text-field#discount-input.white(
                    type="number"
                    min="1"
                    :max="discountType == '%' ? '100' : '' + value.subtotal"
                    :mask="discountType == '%' ? '##' : '#######'"
                    @blur="handleDiscountBlur()"
                    @keydown.enter="$refs.discountInput.blur()"
                    @keydown.esc="$refs.discountInput.blur()"
                    ref="discountInput"
                    v-model="discount"
                    :prefix="discountType == '$' ? discountType : ''" 
                    :suffix="discountType == '%' ? discountType : ''" 
                    v-show="discountInput" 
                    style="width: 8%; position:absolute; top: -10px; left: 56.3%;"
                )
            v-divider(vertical)
            v-flex(:class="stripLayout.contentTile")
                slot(name="content")
            v-flex.text-xs-center.d-flex.justify-center(:class="stripLayout.actionsTile")
                template(v-for="(action, idx) in actions")
                    v-menu(v-if="action.name === 'show_stock_by_warehouse'" offset-y)
                        v-btn(slot="activator" icon :key="idx")
                            v-icon(:color="action.iconColor") {{action.icon}}
                        v-list
                            v-list-tile.black.white--text(style="height: 30px;")
                                v-layout.pb-3(style="width:400px;")
                                    v-flex.xs4.text-sm-center Stock
                                    v-divider(vertical)
                                    v-flex.xs8.text-sm-center Bodega
                            template(v-for="office in whOffices")
                                h3.pl-3 {{office.g_branch_office_address}}
                                v-btn.mx-2(
                                    v-for="wh in office.wh_warehouses"
                                    block
                                    style="width: 415px;"
                                    @click="changeWarehouse(wh)"
                                    :color="wh.wh_warehouse_id === value.active_warehouse ? 'primary' : ''"
                                    :disabled="wh.logical_stock === 0 || isCallCenter")
                                    v-list-tile
                                            v-layout(style="width:400px")
                                                v-flex.xs4 {{wh.logical_stock}}
                                                v-divider(vertical)
                                                v-flex.xs8 {{wh.wh_warehouse_name}}
                                v-divider
                    v-menu(v-if="action.name === 'discount'" offset-y open-on-hover)
                        v-btn(slot="activator" icon :key="idx")
                            v-icon(:color="action.iconColor") {{action.icon}}
                        v-list
                            v-list-tile(style="height: 30px; overflow: hidden;")
                                    v-layout.pb-3(style="width:120px;")
                                        v-flex.xs6.text-sm-center(style="cursor: pointer;")
                                            v-btn.pr-3.display-1.text-sm-center.font-weight-bold.green--text(@click="activateDiscount()" style="width: 40px;") %
                                        v-divider(vertical)
                                        v-flex.xs6.text-sm-center(style="cursor: pointer;")
                                            v-btn.pl-3.display-1.text-sm-center.font-weight-bold.light-green--text(@click="activateDiscount('$')" style="width: 40px;") $
                    v-tooltip(
                        top
                        v-if="action.name === 'price_replace'")
                        v-btn(
                            slot="activator"
                            icon
                            :key="idx"
                            @click="$refs.details.editPrice()"
                            )
                            v-icon(:color="action.iconColor") {{action.icon}}
                        span reemplazo de precio
                    v-tooltip(top v-if="(action.name !== 'price_replace' && action.name !== 'show_stock_by_warehouse' && action.name !== 'discount')")
                        v-btn(slot="activator" icon :key="idx" @click="$emit('action', action.handler)" :disabled="action.name == 'show_wholesale' && item.availableWholesaleDiscounts.length === 0")
                            v-icon(:color="action.iconColor") {{action.icon}}
                        span(v-if="action.name == 'show_wholesale' && item.availableWholesaleDiscounts.length > 0")
                            table(style="width: 100px;")
                                tr.font-weight-bold(v-for="whdc in item.availableWholesaleDiscounts" :class="{'orange--text': item.active_discount && item.active_discount.id == whdc.id}")
                                    td {{whdc.quantity_discount}}+
                                    td {{whdc.percentage_discount == 0 ? '$' + whdc.unit_price_discount : whdc.percentage_discount + '%'}}
                        span(v-else) {{action.tooltip}}
</template>

<script>
/**
 * Component that shows an item list tile, containing different info and
 * functions depending on the computed layout for it.
 */
import CounterControl from '../CounterControl/CounterControl'
import SalesCartItemDetails from './subcomponents/SalesCartItemDetails'
import JSUtils from '@/mixins/JSUtils.js'
import ProductHelper from '@/services/API/helpers/ProductHelper.js'
import { mapGetters, mapState } from 'vuex'
import CloneDeep from 'lodash'
export default {
    name: 'item-strip',
    data: function() {
        return {
            item: {},
            discountInput: false,
            discountType: '%',
        }
    },
    props: {
        /**
         * @description
         * Name(key) of the item property to be controlled by the CounterComponent.
         * @type {string}
         */
        countedPropertyName: {
            type: String,
            default: 'quantity',
        },
        /**
         * @description
         * Enables an slot for inserting content.
         */
        enableContentSlot: {
            type: Boolean,
            default: false,
        },
        /**
         * @description
         * Toggles visibility of the actions area at the end of the strip.
         */
        enableActionsSlot: {
            type: Boolean,
            default: false,
        },
        /**
         * @description
         * Toggles visibility of the Description slot in the middle of the strip.
         */
        enableDescriptionSlot: {
            type: Boolean,
            default: false,
        },
        /**
         * @description
         * Recieves Item to be controlled and displayed by this component.
         */
        value: {
            type: Object,
            default: () => {},
        },
        /**
         * @description
         * Array of objects containing custom actions for the item, if needed.
         * Object format:
         * @example
         *  {
         *      name: 'delete', --> Action Name.
         *      icon: 'delete', --> Material Icon for the action button.
         *      iconColor: 'red darken-2', --> Color for the action button.
         *      handler: this.defaultHandlers.deleteItem, IMPORTANT - Stores function to be triggered on button click.
         *      tooltip: 'eliminar', --> Tooltip to show when hovering action button.
         *  },
         */
        actions: {
            type: Array,
            default: () => [],
        },
        /**
         * @description
         * Object containing info about vuex action to be dispatched when this component's binded item
         * is modified. It needs the state module, the state prop to modify and the action to dispatch.
         *
         * @example
         *  {
         *      module: 'CartModule',
         *      state: 'items',
         *      action: 'setCartItems'
         *  }
         */
        vuexBindings: {
            type: Object,
            default: null,
        },
        isCallCenter: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters('TransactionModule', {
            activeTransaction: 'activeTransaction',
        }),
        ...mapState('CartModule', {
            items: 'items',
        }),

        /**
         * @description this function modifies the layout of the Item Strip, depending on the enabled slots passed by props. It sets the visibility and v-flex grid widths for each tile using class binding.
         * @returns {object} Containing enabled classes for each tile.
         */
        stripLayout: function() {
            if (!this.enableContentSlot && !this.enableActionsSlot) {
                return {
                    detailsTile: { xs10: true },
                    contentTile: { 'disabled-tile': true },
                    actionsTile: { 'disabled-tile': true },
                }
            } else if (!this.enableContentSlot && this.enableActionsSlot) {
                return {
                    detailsTile: { xs7: true },
                    contentTile: { 'disabled-tile': true },
                    actionsTile: { xs3: true },
                }
            } else if (this.enableContentSlot && !this.enableActionsSlot) {
                return {
                    detailsTile: { xs7: true },
                    contentTile: { xs3: true },
                    actionsTile: { 'disabled-tile': true },
                }
            } else if (this.enableContentSlot && this.enableActionsSlot) {
                return {
                    detailsTile: { xs6: true },
                    contentTile: { xs2: true },
                    actionsTile: { xs2: true },
                }
            }
        },
        warehouses: function() {
            if (!this.value.stocks && this.value.stocks.length <= 0) return
            let offices = this.value.stocks
            let warehouses = []
            offices.forEach(office => {
                office.wh_warehouses.forEach(warehouse => {
                    if (warehouse.logical_stock <= 0) return
                    if (
                        warehouses.find(
                            wh =>
                                wh.wh_warehouse_id === warehouse.wh_warehouse_id
                        )
                    )
                        return
                    warehouses.push(warehouse)
                })
            })
            return warehouses
        },
        whOffices() {
            if (!this.value.stocks && this.value.stocks.length <= 0) return
            return this.value.stocks
        },
        discount: {
            get: function() {
                if (this.value.lineDiscount.percentage_discount != null) {
                    this.discountType = '%'
                    return this.value.percentage_discount
                }
                if (this.value.lineDiscount.unit_price_discount != null) {
                    this.discountType = '$'
                    return this.value.unit_price_discount
                }
            },
            set: function(val) {
                if (this.discountType === '%') {
                    if (val > 100) val = 100
                    this.value.lineDiscount.percentage_discount = val
                    this.value.lineDiscount.unit_price_discount = null
                }
                if (this.discountType === '$') {
                    if (val > this.value.subtotal) val = this.value.subtotal
                    this.value.lineDiscount.unit_price_discount = val
                    this.value.lineDiscount.percentage_discount = null
                }
                if (this.val == '') {
                    this.value.lineDiscount.unit_price_discount = null
                    this.value.lineDiscount.percentage_discount = null
                }
                this.item = this.mixDeepClone(
                    ProductHelper.frontendProduct(
                        this.value,
                        this.activeTransaction.id
                    )
                )
                if (this.triggerVuexAction()) return
                //Emit value to parent if no vuex action is defined
                this.$emit(
                    'input',
                    ProductHelper.frontendProduct(
                        this.item,
                        this.activeTransaction.id
                    )
                )
            },
        },
    },
    methods: {
        /**
         * @description
         * Handles the emited value by CounterControl to update the item quantity on cart.
         * If Store Bindings are allowed, it will trigger the designed action. Else, it will
         * fire the input event with the updated item as payload.
         * @param {number} count - new item quantity returned by CounterControl Component
         */

        handleCounter: function(count) {
            //asigns new quantity to item
            this.value.quantity = count
            //recalculates subtotal with it's discounts
            // let subtotal = this.value.sale_price * this.value.quantity

            // this.value.subtotal = subtotal
            // IMPORTANT - Deep clones the item for triggering reactivity
            // for Details component to show the updated subtotal and discounts.
            this.item = this.mixDeepClone(
                ProductHelper.frontendProduct(
                    this.value,
                    this.activeTransaction.id
                )
            )
            //Triggers Vuex Action if defined
            if (this.triggerVuexAction()) return
            //Emit value to parent if no vuex action is defined
            this.$emit(
                'input',
                ProductHelper.frontendProduct(
                    this.value,
                    this.activeTransaction.id
                )
            )
        },
        /**
         * @description
         * Checks if Vuex Store, module and action are setted.
         * If so, fetch cart items from store, finds and updates this component's
         * controled item and dispatch the action for updating the list
         */
        triggerVuexAction() {
            if (
                this.vuexBindings &&
                this.vuexBindings.module &&
                this.vuexBindings.state &&
                this.vuexBindings.action
            ) {
                let items = this.$store.state[this.vuexBindings.module][
                    this.vuexBindings.state
                ]
                const index = items.findIndex(item => item.id == this.value.id)
                items[index] = this.value
                this.$store.dispatch(
                    this.vuexBindings.module + '/' + this.vuexBindings.action,
                    items
                )
                return true
            } else {
                return false()
            }
        },
        changeWarehouse: function(warehouse) {
            this.value.quantity = 1
            this.value.stock = warehouse.logical_stock
            this.value.active_warehouse = warehouse.wh_warehouse_id
            this.item = this.mixDeepClone(
                ProductHelper.frontendProduct(
                    this.value,
                    this.activeTransaction.id
                )
            )
            if (this.triggerVuexAction()) return
            //Emit value to parent if no vuex action is defined
            this.$emit(
                'input',
                ProductHelper.frontendProduct(
                    this.item,
                    this.activeTransaction.id
                )
            )
        },
        activateDiscount: function(type = '%') {
            if (this.discountType != type) {
                this.value.lineDiscount = {
                    percentage_discount: null,
                    lineDiscount: null,
                }
            }
            this.discountInput = true
            this.discountType = type
            this.$nextTick(this.$refs.discountInput.focus)
        },
        handleDiscountBlur() {
            this.discountInput = false
            this.$emit('blur')
        },
        focusCounter() {
            this.$refs.counter.focus()
        },
        focusPriceReplace() {
            this.$refs.details.editPrice()
        },
        handlePriceReplace(e) {
            if (this.value.replaced_price) {
                if (this.value.replaced_price.original == e) {
                    delete this.value.replaced_price
                }
            } else {
                this.value.replaced_price = {}
                this.value.replaced_price.original =
                    this.value.discounted_price || this.value.sale_price
                this.value.replaced_price.replaced = true
            }
            this.value.sale_price = e
            //FIXME: Set for current office price only
            /*
            this.value.sale_prices = this.value.sale_prices.map(prc => {
                prc.sale_price = e
                return prc
            })
            */
            //Object.assign(this.value, ProductHelper.calcSubTotal(this.value))
            this.$emit('price:change', e)
        },
    },
    components: {
        CounterControl,
        SalesCartItemDetails,
    },
    mixins: [JSUtils],
    created() {
        this.item = this.value
    },
    watch: {
        items: function(newVal) {
            this.item = this.mixDeepClone(
                ProductHelper.frontendProduct(
                    this.value,
                    this.activeTransaction.id
                )
            )
            this.$forceUpdate()
        },
    },
}
</script>

<style lang="scss">
#discount-input {
    input[type='number']::-webkit-outer-spin-button,
    input[type='number']::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
        margin: 0 !important;
    }

    input[type='number'] {
        -moz-appearance: textfield !important;
    }
}
/* Disable arrows from number input */
</style>
